
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.297.036a.928.928 0 00-.668.26.928.928 0 00-.027 1.311l15.465 16.084a.928.928 0 001.311.024.928.928 0 00.027-1.312L1.94.319a.928.928 0 00-.643-.283z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.967 8.616A4.553 4.553 0 014.963 6.53zm3.535.284a4.548 4.548 0 10-5.685-5.913l1.567 1.631v-.037a2.69 2.69 0 112.691 2.69H9.05c-.04 0-.079 0-.118-.002zm-2.26 1.04c-1.379.13-2.648.576-3.64 1.226-1.166.766-2.094 1.927-2.094 3.313 0 .711.252 1.323.705 1.805.43.46 1.004.763 1.601.969 1.184.408 2.725.526 4.267.526 1.553 0 3.095-.122 4.277-.536.453-.159.891-.371 1.262-.668l-1.299-1.351a2.846 2.846 0 01-.575.267c-.875.307-2.157.432-3.665.432-1.502 0-2.783-.121-3.662-.425-.433-.148-.7-.321-.852-.482a.726.726 0 01-.203-.537c0-.512.364-1.175 1.256-1.76.866-.57 2.1-.962 3.461-.962.333 0 .657.024.972.067zm7.405 4.311c-.088-1.295-.988-2.375-2.094-3.095a7.423 7.423 0 00-1.642-.79z","clip-rule":"evenodd"}})])
          )
        }
      }
    